
/**
 * @param {string} attr Attribute of the element to toggle
 * @param {HTMLElement} el
 *
 * @return void
 */
export function toggleBooleanAttribute( attr, el ) {
    el.setAttribute( attr, isAttr( attr, el ) ? "false" : "true" );
}

/**
 * @param {string} attr Attribute of the element to check if true
 * @param {HTMLElement} el
 *
 * @return void
 */
export function isAttr( attr, el ) {
    return el.getAttribute( attr ) === "true" ? true : false;
}
